import { render, staticRenderFns } from "./AttributeDisplay.vue?vue&type=template&id=4c6dc53a"
import script from "./AttributeDisplay.vue?vue&type=script&lang=js"
export * from "./AttributeDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports